import { useAdminPermissions } from './useAdminPermissions';
import { useConnectionStatus } from './useConnectionStatus';

/**
 * Returns whether the current user is allowed to message a given target.
 *
 * Policy (single source of truth):
 *   - Admins can message anyone on the platform.
 *   - All other roles can only message users they are connected with.
 *
 * Components consume this hook without knowing the reason.
 */
export function useCanMessage(targetUserId: string): {
  canMessage: boolean;
  isLoading:  boolean;
} {
  const { isAdmin, isLoading: adminLoading } = useAdminPermissions();

  // Always call — hooks cannot be conditional. Result is ignored for admins.
  const { status, loading: statusLoading } = useConnectionStatus(targetUserId);

  if (isAdmin) {
    return { canMessage: true, isLoading: adminLoading };
  }

  return {
    canMessage: status === 'connected',
    isLoading:  adminLoading || statusLoading,
  };
}
